import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BirthdayLink } from "@/components/BirthdayCaptureModal";

const COLS = [
  { title: "Explore", links: [["On This Day", "/"], ["Birthdays", "/birthdays"], ["Died on this day", "/died"], ["Horoscope", "/horoscope"]] },
  { title: "Company", links: [["About", "/about"], ["Editorial Policy", "/editorial-policy"], ["Contact", "/contact"], ["Privacy", "/privacy"]] },
];

const FooterLink = ({ label, to }) => <Link to={to} data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}`} className="hover:text-gold transition-colors">{label}</Link>;

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-paper border-t border-[#e5e7eb] mt-12">
    <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
      <div>
        <Link to="/" className="inline-flex items-center gap-2">
          <img src="/seal-oddlytrue-red-wax.png" alt="OddlyTrue" className="w-9 h-9 object-contain" />
          <span className="text-[18px] font-bold text-ink">Oddly<span className="text-gold">True</span></span>
        </Link>
        <p className="text-[13px] text-ink-muted mt-3 leading-relaxed">Learn, laugh, connect with history. Daily email 7am. 1,000s of searchable events.</p>
      </div>
      {COLS.map((c) => (
        <div key={c.title}>
          <h4 className="text-[11px] font-bold tracking-[0.12em] uppercase text-ink mb-3">{c.title}</h4>
          <ul className="space-y-2 text-[13px] text-ink-muted">
            {c.links.map(([label, to]) => <li key={label}><FooterLink label={label} to={to} /></li>)}
          </ul>
        </div>
      ))}
      <div>
        <h4 className="text-[11px] font-bold tracking-[0.12em] uppercase text-ink mb-3">Newsletter</h4>
        <BirthdayLink
          testid="footer-newsletter-cta"
          source="footer_newsletter"
          className="!inline-flex items-center gap-1.5 bg-ink !text-white rounded-full px-5 py-2 !text-[13px] font-semibold hover:bg-gold hover:!text-ink hover:!no-underline transition-colors"
          label={<>Get daily email 7am <ArrowRight className="w-3.5 h-3.5" /></>}
        />
      </div>
    </div>
    <div className="max-w-6xl mx-auto px-6 border-t border-[#e5e7eb] mt-2 py-6 flex flex-col md:flex-row justify-between items-center gap-2">
      <p className="text-[11px] text-[#9ca3af]">All rights reserved</p>
      <div className="flex gap-4 text-[11px] text-[#9ca3af]">
        <Link to="/about" className="hover:text-ink transition-colors">About</Link>
        <Link to="/contact" className="hover:text-ink transition-colors">Contact</Link>
        <Link to="/privacy" className="hover:text-ink transition-colors">Privacy</Link>
      </div>
    </div>
    <div data-testid="publishing-band" className="border-t border-[#e5e0d6] bg-[#fbf8f1] py-8 px-6">
      <div className="max-w-5xl mx-auto flex flex-col items-center">
        <div className="flex items-center gap-3 mb-3">
          <img
            src="/seal-oddlytrue-red-wax.png"
            alt="OddlyTrue Black Wax Seal"
            className="w-14 h-14 object-contain opacity-90"
            width={56}
            height={56}
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/oddlytrue-mark.png"; }}
          />
          <span className="text-[11px] tracking-[0.25em] uppercase text-[#111827] font-medium">OddlyTrue Publishing</span>
        </div>
        <div className="flex gap-4 text-[10px] text-[#9ca3af] tracking-widest uppercase">
          <a href="https://curiovault.co" data-testid="footer-curiovault" className="hover:text-[#111827] transition-colors">CurioVault.co</a>
          <span>•</span>
          <a href="https://astralogico.com" data-testid="footer-astralogico" className="hover:text-[#111827] transition-colors">AstraLogico.com</a>
        </div>
        <p data-testid="footer-copyright" className="mt-3 text-[9px] text-[#9ca3af]">
          © {new Date().getFullYear()} OddlyTrue Publishing • Est. 2024
        </p>
      </div>
    </div>
  </footer>
);
